import { MISSING_AGREEMENT_FIELD } from './contractIqVerification.config';

export const getNormalFieldNames = (fields: string[]) => {
  return fields.filter(field => field !== MISSING_AGREEMENT_FIELD);
};

export const toggleFieldSelection = (selectedFields: string[], field: string) => {
  const normalSelections = getNormalFieldNames(selectedFields);

  return normalSelections.includes(field)
    ? normalSelections.filter(selectedField => selectedField !== field)
    : [...normalSelections, field];
};

export const toggleAllFieldSelections = (selectedFields: string[], fieldNames: string[]) => {
  const normalFieldNames = getNormalFieldNames(fieldNames);
  const allSelected = normalFieldNames.length > 0
    && normalFieldNames.every(field => selectedFields.includes(field));

  return allSelected ? [] : normalFieldNames;
};

export const toggleMissingAgreementSelection = (selectedFields: string[]) => {
  return selectedFields.includes(MISSING_AGREEMENT_FIELD)
    ? []
    : [MISSING_AGREEMENT_FIELD];
};
